const namespace = 'search/'

// Getters
export const CATEGORIES = 'categories'
export const PAGINATION = 'pagination'
export const SEARCH_QUERIES = 'searchQueries'
export const SEARCH_RESULTS = 'searchResults'

export const SEARCH_CATEGORIES = namespace + CATEGORIES
export const SEARCH_PAGINATION = namespace + PAGINATION
export const SEARCH_SEARCH_QUERIES = namespace + SEARCH_QUERIES
export const SEARCH_SEARCH_RESULTS = namespace + SEARCH_RESULTS

// Mutations
export const SET_CATEGORIES = 'setCategories'
export const PURGE_CATEGORIES = 'purgeCategories'
export const SET_PAGINATION = 'setPagination'
export const PURGE_PAGINATION = 'purgePagination'
export const SET_SEARCH_QUERY = 'setSearchQuery'
export const PURGE_SEARCH_QUERIES = 'purgeSearchQueries'
export const SET_SEARCH_RESULTS = 'setSearchResults'
export const PREPEND_SEARCH_RESULTS = 'prependSearchResults'
export const PURGE_SEARCH_RESULTS = 'purgeSearchResults'
export const UPDATE_SEARCH_RESULT = 'updateSearchResult'

export const SEARCH_SET_CATEGORIES = namespace + SET_CATEGORIES
export const SEARCH_PURGE_CATEGORIES = namespace + PURGE_CATEGORIES
export const SEARCH_SET_PAGINATION = namespace + SET_PAGINATION
export const SEARCH_PURGE_PAGINATION = namespace + PURGE_PAGINATION
export const SEARCH_SET_SEARCH_QUERY = namespace + SET_SEARCH_QUERY
export const SEARCH_PURGE_SEARCH_QUERIES = namespace + PURGE_SEARCH_QUERIES
export const SEARCH_SET_SEARCH_RESULTS = namespace + SET_SEARCH_RESULTS
export const SEARCH_PREPEND_SEARCH_RESULTS = namespace + PREPEND_SEARCH_RESULTS
export const SEARCH_PURGE_SEARCH_RESULTS = namespace + PURGE_SEARCH_RESULTS
export const SEARCH_UPDATE_SEARCH_RESULT = namespace + UPDATE_SEARCH_RESULT



// WEBPACK FOOTER //
// ./src/store/search/searchModule.types.js